import React from 'react';
import MainComponent from './maincomponent/MainComponent';
import './App.css';

function App() {
  return (
    <React.Fragment>
      <MainComponent />
    </React.Fragment>
  );
}

export default App;
